/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetTikTokCreatorInfoQueryResponse, SocialExportGetTikTokCreatorInfoPathParams, SocialExportGetTikTokCreatorInfo400, SocialExportGetTikTokCreatorInfo401, SocialExportGetTikTokCreatorInfo403, SocialExportGetTikTokCreatorInfo404 } from "../models/SocialExportGetTikTokCreatorInfo";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportGetTikTokCreatorInfo } from "../axios/socialExportGetTikTokCreatorInfo";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportGetTikTokCreatorInfoQueryKey = (connectionId: SocialExportGetTikTokCreatorInfoPathParams["connectionId"]) => ["api-v2", { url: '/social-export/v1/platforms/tiktok/:connectionId/creator-info', params: {connectionId:connectionId} }] as const

export type SocialExportGetTikTokCreatorInfoQueryKey = ReturnType<typeof socialExportGetTikTokCreatorInfoQueryKey>

export function socialExportGetTikTokCreatorInfoQueryOptions(connectionId: SocialExportGetTikTokCreatorInfoPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportGetTikTokCreatorInfoQueryKey(connectionId)
        return queryOptions<SocialExportGetTikTokCreatorInfoQueryResponse, ResponseErrorConfig<SocialExportGetTikTokCreatorInfo400 | SocialExportGetTikTokCreatorInfo401 | SocialExportGetTikTokCreatorInfo403 | SocialExportGetTikTokCreatorInfo404>, SocialExportGetTikTokCreatorInfoQueryResponse, typeof queryKey>({
         enabled: !!(connectionId),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportGetTikTokCreatorInfo(connectionId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns TikTok creator profile and permission info (privacy options, comment/duet/stitch settings, max video duration). Use when rendering the Post to TikTok page per Content Sharing Guidelines.
 * @summary Get TikTok creator info for a connection
 * {@link /social-export/v1/platforms/tiktok/:connectionId/creator-info}
 */
export function useSocialExportGetTikTokCreatorInfo<TData = SocialExportGetTikTokCreatorInfoQueryResponse, TQueryData = SocialExportGetTikTokCreatorInfoQueryResponse, TQueryKey extends QueryKey = SocialExportGetTikTokCreatorInfoQueryKey>(connectionId: SocialExportGetTikTokCreatorInfoPathParams["connectionId"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportGetTikTokCreatorInfoQueryResponse, ResponseErrorConfig<SocialExportGetTikTokCreatorInfo400 | SocialExportGetTikTokCreatorInfo401 | SocialExportGetTikTokCreatorInfo403 | SocialExportGetTikTokCreatorInfo404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportGetTikTokCreatorInfoQueryKey(connectionId)
         

         const query = useQuery({
          ...socialExportGetTikTokCreatorInfoQueryOptions(connectionId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportGetTikTokCreatorInfo400 | SocialExportGetTikTokCreatorInfo401 | SocialExportGetTikTokCreatorInfo403 | SocialExportGetTikTokCreatorInfo404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}